import { GovernanceSettings } from './../../../../core/services/governance-settings.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

/* export interface Image {
  url: string;
  name: string;
  size: number;
  status: string;
  file_id: string;
  isPublic: boolean;
  directory: string;
  extension: string;
  file_type: string;
  mime_type: string;
} */

export interface Section {
  image: any;
  en_title: string;
  te_title: string;
  en_content: string;
  te_content: string;
}
@Component({
  selector: 'app-government-offices-settings',
  templateUrl: './government-offices-settings.component.html',
  styleUrls: ['./government-offices-settings.component.scss']
})
export class GovernmentOfficesSettingsComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */
  sections = [
    {
      id: "grampanchayat",
      title: "Gram Panchayat"
    },{
      id: "village_exhibition_center",
      title: "Village exhibition center"
    },
    {
      id: "primary_healthcare_center",
      title: "Primary Healthcare Center"
    },{
      id: "one_zero_four_service",
      title: "One Zero Four Service"
    },{
      id:"anganwadi_centers",
      title: "Anganwadi centers"
    },{
      id: "schools_and_institutes",
      title: "Schools and institutes"
    }, {
      id: "community_water_supplys",
      title: "Community water supplys"
    },{
      id: "sanitization",
      title: "Sanitization"
    }, {
      id: "irrigation_and_agriculture",
      title: "Irrigation and agriculture"
    },

    {
      id: "electricity_transmission",
      title: "Electricity transmission"
    }, {
      id: "civil_supplies",
      title: "Civil supplies"
    },
    {
      id: "revenue_and_land_survey",
      title: "Revenue and land survey"
    },{
      id: "law_and_order",
      title: "Law and order"
    },
    {
      id: "self_help_groups",
      title: "Self help groups"
    },

    {
      id: "milk_diaries",
      title: "Milk diaries"
    },

    {
      id: "ambulance_services",
      title: "Ambulance services"
    },
    {
      id: "telecommunications",
      title: "Telecommunications"
    },
    {
      id: "postal_services",
      title: "Postal services"
    },

    {
      id: "animal_husbandry",
      title: "Animal husbandry"
    },

    {
      id: "community_centers",
      title: "Community centers"
    },{
      id: "hundred_percent_literacy",
      title: "Hundred percent literacy"
    },{
      id: "hundred_percentage_employment",
      title: "Hundred percentage employment"
    },{
      id: "medical",
      title: "Medical"
    },{
      id: "organic_farming_bio_farming",
      title: "organic farming bio farming"
    },{
      id: "tsiic",
      title: "Tsiic"
    },{
      id: "solar_plant_and_lighting",
      title: "Solar plant and lighting"
    },{
      id: "lakes_and_canals",
      title: "Lakes and canals"
    },{
      id: "adimanavula_gundu_and_burunu",
      title: "Adimanavula gundu and burunu"
    }
  ];

  governmentOfficesSettings!:GovernanceSettings;
  selectedSection!: Section;
  lang!:  string;

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 4,
    slidesPerGroup: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: false,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    navigation: {
      nextEl: '.initiatives-button-next',
      prevEl: '.initiatives-button-prev',
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  };
  selectedSectionId!: string;
/* ------------------------------- Constructor ------------------------------ */

  constructor(private route: ActivatedRoute) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
    this.governmentOfficesSettings = this.route.snapshot.data.governmentOfficesSettings;
    this.route.paramMap.subscribe(paramMap=> {
      const id = paramMap.get('id');
      if(id){
        this.selectedSectionId = id;
        this.selectedSection = this.governmentOfficesSettings[id];
      }
    });
    this.route.queryParamMap.subscribe(queryParamMap => {
      this.lang = queryParamMap.get('lang') ?? 'en';
    });
  }
}

